import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyWallet = lazy(() => import('./Wallet'));

export const Wallet: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyWallet {...props} />
	</Suspense>
);
